import PropTypes from 'prop-types';
import React from 'react';

import { PandoraTypes } from '../../constants/SourceTypes';

import AlbumGridItem from './AlbumGridItem';
import ArtistGridItem from './ArtistGridItem';
import ArtistTopSongsGridItem from './ArtistTopSongsGridItem';
import CatalogGridItem from './CatalogGridItem';
import PlaylistGridItem from './PlaylistGridItem';
import PodcastEpisodeGridItem from './PodcastEpisodeGridItem';
import PodcastProgramGridItem from './PodcastProgramGridItem';
import StationGridItem from './StationGridItem';
import TrackGridItem from './TrackGridItem';

/**
 * MixedGridItem determines which type-specific T3 grid item to render based
 * on pandoraType. Useful for mixed-type grids and when you just don't feel like
 * specifying which type-specific GridItem to use.
 *
 * See CatalogGridItem, lib/GridItem and the various type-specific GridItem
 * components for additional available props.
 *
 * If we don't have a pandoraType set we can assume we should render a blank item
 * which appears as a placeholder.
 */
class MixedGridItem extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    pandoraType: PropTypes.string,
  };

  render() {
    const { pandoraType } = this.props;
    switch (pandoraType) {
      case PandoraTypes.ALBUM:
        return <AlbumGridItem {...this.props} />;
      case PandoraTypes.SONG:
        return <TrackGridItem {...this.props} />;
      case PandoraTypes.ARTIST:
        return <ArtistGridItem {...this.props} />;
      case PandoraTypes.PLAYLIST:
        return <PlaylistGridItem {...this.props} />;
      case PandoraTypes.STATION:
        return <StationGridItem {...this.props} />;
      case PandoraTypes.ARTIST_TOP_SONGS:
        return <ArtistTopSongsGridItem {...this.props} />;
      case PandoraTypes.PODCAST:
        return <PodcastProgramGridItem {...this.props} />;
      case PandoraTypes.EPISODE:
        return <PodcastEpisodeGridItem {...this.props} />;
      default:
        return <CatalogGridItem {...this.props} blankItem={true} />;
    }
  }
}

export default MixedGridItem;
